module.exports = __webpack_public_path__ + "static/media/OTCXR3.900dd092.png";